import { render, staticRenderFns } from "./transTab.vue?vue&type=template&id=5a245406&scoped=true&lang=pug&"
import script from "./transTab.vue?vue&type=script&lang=js&"
export * from "./transTab.vue?vue&type=script&lang=js&"
import style0 from "./transTab.vue?vue&type=style&index=0&id=5a245406&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a245406",
  null
  
)

export default component.exports